var pym = require("./lib/pym");
require("./lib/webfonts");
var pymChild;
var skipLabels = ["Group", "key", "values"];
var renderGroupedBarChart = require("./renderGroupedBars");

// Initialize the graphic.
var onWindowLoaded = function() {
  var reading_data = formatData(window.READING_DATA);
  var math_data = formatData(window.MATH_DATA);
  var options = window.OPTIONS;
  render(reading_data, math_data, options);

  window.addEventListener("resize", () => render(reading_data, math_data, options));

  pym.then(child => {
    pymChild = child;
    pymChild.sendHeight();
  });
};

// Format graphic data for processing by D3.
var formatData = function(data) {
  var output = data.map(function(d) {
    var series = {
      key: d.Group,
      values: []
    };

    for (var [k, v] of Object.entries(d)) {
      if (skipLabels.indexOf(k) > -1) {
        continue;
      }

      series.values.push({
        label: k,
        amt: Number(v)
      });
    }

    return series;
  });

  return output;
};

// Render the graphic(s). Called by pym with the container width.
var render = function(reading_data, math_data, options) {
  // Render the chart!
  var container = "#reading-bar-chart";
  var element = document.querySelector(container);
  var container2 = "#math-bar-chart";
  var width = element.offsetWidth;

  renderGroupedBarChart({
    container,
    width,
    data: reading_data,
    options,
    labelColumn: "label",
    valueColumn: "amt"
  });

  renderGroupedBarChart({
    container: container2,
    width,
    data: math_data,
    options,
    labelColumn: "label",
    valueColumn: "amt"
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
